import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Dashboard, PageLayout } from '@components';
import { BackButton, Button, DateString, HeadContent, Icon, PriceString, } from '@fourthwall/components';
import { DownloadIcon } from '@fourthwall/icons';
import { isWebView } from '@fourthwall/utils';
import { routing } from '@utils/routing';
import { AnalyticsCard } from '../../analyticsModule/components/AnalyticsCard/AnalyticsCard';
import { AnalyticsFiltersSelect } from '../../analyticsModule/components/AnalyticsFilterSelect/AnalyticsFiltersSelect';
import { AnalyticsFiltersButton } from '../../analyticsModule/components/AnalyticsFiltersButton/AnalyticsFiltersButton';
import { AnalyticsReportLayout } from '../../analyticsModule/components/AnalyticsReportLayout/AnalyticsReportLayout';
import { AnalyticsTable } from '../../analyticsModule/components/AnalyticsTable/AnalyticsTable';
import { AnalyticsToolbar } from '../../analyticsModule/components/AnalyticsToolbar/AnalyticsToolbar';
import { AnalyticsCompareDateRangeSelect } from '../../analyticsModule/components/tools/AnalyticsCompareDateRangeSelect/AnalyticsCompareDateRangeSelect';
import { AnalyticsDateRangeSelect } from '../../analyticsModule/components/tools/AnalyticsDateRangeSelect/AnalyticsDateRangeSelect';
import { AnalyticsGroupBySelect } from '../../analyticsModule/components/tools/AnalyticsGroupBySelect/AnalyticsGroupBySelect';
import { useAnalyticsParams } from '../../modules/AnalyticsParams/hooks/useAnalyticsParams';
import { useAnalyticsReport } from './hooks/useAnalyticsReport';
export const AnalyticsReport = () => {
    const location = useLocation();
    const locationState = location.state;
    const { title } = useAnalyticsReport();
    const [showAside, setShowAside] = useState(false);
    const { dateRange, compareDateRange, groupBy } = useAnalyticsParams();
    const backButtonProps = (() => {
        if (locationState?.from) {
            return {
                label: locationState.from.label,
                to: {
                    pathname: locationState.from.location.pathname,
                    search: locationState.from.location.search,
                },
            };
        }
        return {
            label: 'Reports',
            to: routing.analyticsV2.reports.self,
        };
    })();
    const formatPrice = (value) => React.createElement(PriceString, { value: value });
    const formatDate = (value) => React.createElement(DateString, { date: value });
    const columns = [
        { id: 'date', label: 'Day' },
        {
            id: 'name',
            label: 'Name',
        },
        {
            id: 'age',
            label: 'Age',
        },
        {
            id: 'country',
            label: 'Country',
        },
        {
            id: 'email',
            label: 'Email',
        },
        {
            id: 'phone',
            label: 'Phone',
            tooltip: {
                content: 'Change = Newly subscribed + Returning + Migrated from - Migrated to - Cancelled',
            },
        },
        {
            id: 'subscribed',
            label: 'Subscribed',
            tooltip: {
                title: 'Total change in member count:',
                content: 'Change = Newly subscribed + Returning + Migrated from - Migrated to - Cancelled',
            },
        },
        {
            id: 'returning',
            label: 'Returning',
        },
    ];
    const countries = ['Poland', 'Germany', 'France', 'USA', 'UK', 'Canada'];
    const names = [
        'Anna',
        'Jan',
        'Kasia',
        'Piotr',
        'Marek',
        'Julia',
        'Tomek',
        'Zofia',
        'Ola',
        'Paweł',
    ];
    const data = Array.from({ length: 50 }, (_, i) => {
        const name = names[Math.floor(Math.random() * names.length)];
        return {
            date: [
                new Date(2024, Math.floor(Math.random() * 6), Math.floor(Math.random() * 28) + 1),
                new Date(2024, Math.floor(Math.random() * 6), Math.floor(Math.random() * 28) + 1),
            ],
            name: [name, name],
            age: [Math.floor(Math.random() * 40) + 20, Math.floor(Math.random() * 40) + 20],
            country: [
                countries[Math.floor(Math.random() * countries.length)],
                countries[Math.floor(Math.random() * countries.length)],
            ],
            email: [
                `${name.toLowerCase()}${i + 1}@example.com`,
                `${name.toLowerCase()}${i + 1}@example.com`,
            ],
            phone: [`+48 500-${100 + i}`, `+48 500-${100 + i}`],
            subscribed: [
                {
                    value: Math.floor(Math.random() * 1000),
                    breakdown: {
                        title: 'Breadown title',
                        items: [
                            { label: 'Item 1', value: 24 },
                            { label: 'Item 2', value: 49 },
                            { label: 'Item 3', value: 35 },
                        ],
                    },
                },
                {
                    value: Math.floor(Math.random() * 1000),
                    breakdown: {
                        title: 'Breadown title',
                        items: [
                            { label: 'Item 1', value: 24 },
                            { label: 'Item 2', value: 49 },
                            { label: 'Item 3', value: 35 },
                        ],
                    },
                },
            ],
            returning: [Math.floor(Math.random() * 500), Math.floor(Math.random() * 500)],
        };
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: title, titleTemplate: isWebView() ? title : undefined }),
        React.createElement(PageLayout, { size: "full" },
            React.createElement(Dashboard.Section, { name: isWebView() ? undefined : title, topContent: React.createElement(BackButton, { ...backButtonProps }) },
                React.createElement(AnalyticsReportLayout, { toolbar: React.createElement(AnalyticsToolbar, { actions: React.createElement(React.Fragment, null,
                            React.createElement(Button, { leftIcon: React.createElement(Icon, { component: DownloadIcon, height: 18 }), label: "Export", appearance: "secondary", size: "small", onClick: () => { } }),
                            React.createElement(AnalyticsFiltersButton, { onClick: () => setShowAside(!showAside) })) },
                        React.createElement(AnalyticsDateRangeSelect, { ...dateRange }),
                        React.createElement(AnalyticsCompareDateRangeSelect, { ...compareDateRange }),
                        React.createElement(AnalyticsGroupBySelect, { ...groupBy })), aside: React.createElement(AnalyticsFiltersSelect, { filters: [
                            {
                                title: 'Section 1',
                                items: [
                                    { value: 'item1', label: 'Item 1', checked: false },
                                    { value: 'item2', label: 'Item 2', checked: false },
                                ],
                            },
                            {
                                title: 'Section 2',
                                items: [
                                    { value: 'item1', label: 'Item 1', checked: false },
                                    { value: 'item2', label: 'Item 2', checked: false },
                                    { value: 'item3', label: 'Item 3', checked: false },
                                    { value: 'item4', label: 'Item 4', checked: false },
                                ],
                            },
                            {
                                title: 'Section 3',
                                items: [
                                    { value: 'item1', label: 'Item 1', checked: false },
                                    { value: 'item2', label: 'Item 2', checked: false },
                                    { value: 'item3', label: 'Item 3', checked: false },
                                ],
                            },
                        ], onChange: () => { } }), showAside: showAside },
                    React.createElement(React.Fragment, null,
                        React.createElement(AnalyticsCard, { type: "lineChart", title: "Shop profit 2", titleTooltip: "Something", value: [26896.1, 23896.34], formatValue: formatPrice, formatXAxis: formatDate, data: [
                                {
                                    label: 'Sprzedaż',
                                    data: [
                                        { value: 100, label: '2023-01-01T00:00:00Z' },
                                        { value: 150, label: '2023-02-15T00:00:00Z' },
                                        { value: 200, label: '2023-03-01T00:00:00Z' },
                                        { value: 180, label: '2023-04-15T00:00:00Z' },
                                        { value: 250, label: '2023-05-01T00:00:00Z' },
                                        { value: 300, label: '2023-06-15T00:00:00Z' },
                                        { value: 280, label: '2023-07-01T00:00:00Z' },
                                        { value: 320, label: '2023-08-15T00:00:00Z' },
                                        { value: 350, label: '2023-09-01T00:00:00Z' },
                                        { value: 400, label: '2023-10-15T00:00:00Z' },
                                        { value: 300, label: '2023-11-01T00:00:00Z' },
                                        { value: 308, label: '2023-12-15T00:00:00Z' },
                                        { value: 199, label: '2024-01-01T00:00:00Z' },
                                        { value: 298, label: '2024-02-15T00:00:00Z' },
                                        { value: 345, label: '2024-03-01T00:00:00Z' },
                                        { value: 328, label: '2024-04-15T00:00:00Z' },
                                        { value: 403, label: '2024-05-01T00:00:00Z' },
                                        { value: 495, label: '2024-06-15T00:00:00Z' },
                                    ],
                                },
                                {
                                    label: 'Zysk',
                                    data: [
                                        { value: 208, label: '2023-01-01T00:00:00Z' },
                                        { value: 290, label: '2023-02-15T00:00:00Z' },
                                        { value: 303, label: '2023-03-01T00:00:00Z' },
                                        { value: 456, label: '2023-04-15T00:00:00Z' },
                                        { value: 400, label: '2023-05-01T00:00:00Z' },
                                        { value: 403, label: '2023-06-15T00:00:00Z' },
                                        { value: 448, label: '2023-07-01T00:00:00Z' },
                                        { value: 360, label: '2023-08-15T00:00:00Z' },
                                        { value: 404, label: '2023-09-01T00:00:00Z' },
                                        { value: 299, label: '2023-10-15T00:00:00Z' },
                                        { value: 302, label: '2023-11-01T00:00:00Z' },
                                        { value: 210, label: '2023-12-15T00:00:00Z' },
                                        { value: 225, label: '2024-01-01T00:00:00Z' },
                                        { value: 240, label: '2024-02-15T00:00:00Z' },
                                        { value: 260, label: '2024-03-01T00:00:00Z' },
                                        { value: 245, label: '2024-04-15T00:00:00Z' },
                                        { value: 275, label: '2024-05-01T00:00:00Z' },
                                        { value: 290, label: '2024-06-15T00:00:00Z' },
                                    ],
                                },
                            ] }),
                        React.createElement(AnalyticsTable, { columns: columns, data: data, maxHeight: 600, activeColumnId: "age", sorting: {
                                columnId: 'date',
                                direction: 'desc',
                            } })))))));
};
